import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AssociationSelect from 'components/AssociationSelect'
import {
  selectUserWorkPeriodRoles,
  selectActivenessFormDataUserWorkPeriod
} from 'workspace/selectors'
import { changeActivenessFormUserWorkPeriod } from 'workspace/actions'
import Input from 'components/Input'
import { intlShape, injectIntl, defineMessages } from 'react-intl'
import { compose } from 'redux'
import { selectUserWorkPeriodFieldError } from './selectors'

const messages = defineMessages({
  label: {
    id: 'workspace.menu.activenessForm.userRoleLabel',
    defaultMessage: 'Role'
  }
})

const RealizationMenuUserInput = ({ id, intl, roles, onChange, error }) => (
  <Input
    label={intl.formatMessage(messages.label)}
    error={error}
    nested
    style={{ minWidth: 160 }}
    className='workspace-form__control'
  >
    <AssociationSelect
      options={roles}
      value={id}
      onChange={newId => onChange({ role: newId })}
      labelMapper={role => role.name}
    />
  </Input>
)

RealizationMenuUserInput.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, id: PropTypes.number })
  ),
  id: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  intl: intlShape
}

const mapStateToProps = (state, ownProps) => {
  const data = selectActivenessFormDataUserWorkPeriod(state, ownProps.idx)

  return {
    roles: selectUserWorkPeriodRoles(state),
    id: data.role,
    error: selectUserWorkPeriodFieldError(state, ownProps.idx, 'Role')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: data =>
    dispatch(changeActivenessFormUserWorkPeriod({ idx: ownProps.idx, data }))
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(RealizationMenuUserInput)
